import { Box, Stack } from "@mui/material";

import { useMediaQuery } from "@/common/hooks/useMediaQuery";

type PeerToPeerPrimaryCampaignSummaryLayoutProps = {
  slots: {
    banner?: React.ReactNode;
    organizationLogo: React.ReactNode;
    status?: React.ReactNode;
    coreInfo?: React.ReactNode;
    campaignTarget?: React.ReactNode;
    divider?: React.ReactNode;
  };
};

export const PeerToPeerPrimaryCampaignSummaryLayout = ({ slots }: PeerToPeerPrimaryCampaignSummaryLayoutProps) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <Stack width="100%" direction="column" alignItems="flex-start" gap={2}>
      {!isSmallScreen && slots.banner && <Box sx={{ marginBlockEnd: 0.5, width: "100%" }}>{slots.banner}</Box>}
      {slots.organizationLogo}
      {!isSmallScreen && slots.divider}
      {slots.status && <Box marginBlockStart={0.5}>{slots.status}</Box>}
      {isSmallScreen && slots.coreInfo}
      {slots.campaignTarget}
    </Stack>
  );
};
